import styled, { css } from 'styled-components'

type ButtonProps = {
  backgroundColor?: string
  width?: number
}

type ButtonContainerProps = {
  width?: number
  disabled?: boolean
}

export const ButtonContainer = styled.div<ButtonContainerProps>`
  margin: 1px;
  max-width: 100%;
  width: ${({ width }) => (width ? `${width}%` : 'fit-content')};
  height: 56px;

  ${({ disabled }) =>
    !disabled &&
    css`
      .button::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 100px;
        transition: opacity 0.7s ease;
        background: linear-gradient(135deg, #0abaad 0%, #065a5a 100%);
        opacity: 0;
        z-index: -1;
      }
      &:hover {
        .button::after {
          opacity: 1;
        }
        .button {
          color: #ffffff;
          border: none;
          padding: 0 30px;
        }
      }
    `}
`

export const Button = styled.button<ButtonProps>`
  padding: 0 28px;

  color: ${(props) => props.theme.colors.primary};
  background-color: transparent;

  border: 2px solid ${(props) => props.theme.colors.primary};
  border-radius: 100px;
  height: 100%;

  font-size: 24px;
  font-weight: 700;
  line-height: 29.26px;

  max-width: 100%;
  width: ${({ width }) => `${width}%` || 'fit-content'};
  position: relative;
  z-index: 0;

  &:disabled {
    cursor: default;
  }

  @media (max-width: 500px) {
    padding: 0 16px;
    font-size: 14px;
    line-height: 9.75px;

    &:hover {
      padding: 0 18px;
    }
  }
`
